var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.5H8.5V1.5C8.5 1.36739 8.44732 1.24021 8.35355 1.14645C8.25979 1.05268 8.13261 1 8 1C7.86739 1 7.74021 1.05268 7.64645 1.14645C7.55268 1.24021 7.5 1.36739 7.5 1.5V2.5H2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V11C1.5 11.2652 1.60536 11.5196 1.79289 11.7071C1.98043 11.8946 2.23478 12 2.5 12H4.96L3.60938 13.6875C3.52649 13.7911 3.48816 13.9234 3.50282 14.0552C3.51747 14.1871 3.5839 14.3077 3.6875 14.3906C3.7911 14.4735 3.92338 14.5118 4.05524 14.4972C4.1871 14.4825 4.30774 14.4161 4.39062 14.3125L6.24 12H9.76L11.6094 14.3125C11.6504 14.3638 11.7012 14.4065 11.7587 14.4382C11.8162 14.4699 11.8795 14.4899 11.9448 14.4972C12.01 14.5044 12.0761 14.4988 12.1392 14.4805C12.2023 14.4622 12.2612 14.4317 12.3125 14.3906C12.3638 14.3496 12.4065 14.2988 12.4382 14.2413C12.4699 14.1838 12.4899 14.1205 12.4972 14.0552C12.5044 13.99 12.4988 13.9239 12.4805 13.8608C12.4622 13.7977 12.4317 13.7388 12.3906 13.6875L11.04 12H13.5C13.7652 12 14.0196 11.8946 14.2071 11.7071C14.3946 11.5196 14.5 11.2652 14.5 11V3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5ZM13.5 11H2.5V3.5H13.5V11Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas.6d71e477fdb4c0dbca49f5fe6ca5d034.svg";